// 一般揪活動的類別；揪運動與揪旅伴皆為獨立產品入口，不放在此清單。
// All activity category options MUST come from here — never hardcode in components.

export const EVENT_CATEGORIES = [
  '美食',
  '文藝',
  '聚會',
  '戶外',
  '學習',
  '其他',
];

// 底層 events 表仍以 category === '運動' 相容既有資料；UI 直接從揪運動入口選 subcategory。
export const SPORT_SUBCATEGORIES = [
  '羽球',
  '匹克球',
  '壁球',
  '桌球',
  '網球',
  '籃球',
  '排球',
  '慢跑',
  '健身',
  '爬山',
  '游泳',
  '自行車',
  '保齡球',
  '其他運動',
];

export const SPORT_CATEGORY = '運動';
